import { RequireOnly } from '@pelicargo/types';
import { Prisma } from '@prisma/client';

export const departsFromUSA = ({
  origin_airport,
}: RequireOnly<
  Prisma.FlightSegmentGetPayload<{
    include: { origin_airport: { select: { address: true } } };
  }>,
  'origin_airport'
>) => {
  return origin_airport?.address?.country === 'US';
};
